export function removeFileExtension(filename: string): string {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) return filename;
  return filename.substring(0, lastDotIndex);
}

export function downloadFile(file: File) {
  const url = window.URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  window.URL.revokeObjectURL(url);
}

export function downloadData(data: string, filename: string) {
  const a = document.createElement("a");
  a.href = data;
  a.download = filename;
  a.click();
}

export function downloadText(text: string, filename: string) {
  const blob = new Blob([text], { type: "text/plain" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

export async function downloadCanvas(
  canvas: HTMLCanvasElement,
  fileType: string,
  fileName: string,
) {
  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Failed to generate QR code"));
      } else {
        resolve(blob);
      }
    }, fileType);
  });

  const file = new File([blob], fileName, { type: fileType });

  downloadFile(file);
}

export function paseFileNameFromContentDisposition(
  str: string | undefined | null,
  defaultStr: string,
) {
  if (!str) return defaultStr;

  const match = str.match(/filename="(.+)"/);
  return match?.[1] || defaultStr;
}

export const supportedVideoExtensions = [
  "mp4",
  "webm",
  "ogg",
  "mov",
  "avi",
  "mkv",
  "flv",
  "wmv",
  "3gp",
];
